import React from "react";
import "./termsModal.css"; // Create this CSS or add to your existing CSS

const TermsModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={e => e.stopPropagation()}>
        <button className="terms-modal__close" onClick={onClose}>Cerrar</button>
        <h2>Términos y Condiciones</h2>
        <div className="terms-modal__content">
          <p>
            Antes de proceder con el uso de la plataforma GourmetJobs y sus servicios, debes leer
            detenidamente los siguientes Términos y Condiciones. Si no estás de acuerdo con alguno
            de los puntos aquí establecidos, no podrás acceder ni utilizar este sitio web ni los servicios
            que ofrece.
          </p>
          <p>
            Al registrarte y utilizar cualquiera de nuestras plataformas (<a href="https://www.gourmetjobs.cl" target="_blank" rel="noopener noreferrer">www.gourmetjobs.cl</a> y sitios
            web derivados), se entiende que el Usuario conoce y acepta los términos y condiciones que
            se establecen a continuación, entregando su total conformidad con las condiciones
            presentadas. Estos términos y condiciones son válidos para el uso de GourmetJobs y sus
            plataformas derivadas.
          </p>

          <h3>I. ¿Qué es GourmetJobs y cómo funciona?</h3>
          <p>
            GourmetJobs es una plataforma digital que conecta a empresas del sector gastronómico
            (restaurantes, bares, cafeterías, etc.) con profesionales calificados del rubro (chefs,
            garzones, baristas, etc.). La plataforma permite a las empresas publicar ofertas de empleo y
            a los profesionales buscar oportunidades laborales, facilitando así el reclutamiento en el
            sector gastronómico.
          </p>
          <p>En GourmetJobs, ofrecemos los siguientes servicios:</p>
          <ul>
            <li><b>Bolsa de Trabajo:</b> Accede a una amplia variedad de ofertas laborales en el rubro
            gastronómico, ajustadas a las preferencias y criterios de búsqueda de los usuarios.</li>
            <li><b>Marketplace de Capacitación:</b> Accede a cursos y capacitaciones para mejorar tus
            habilidades en el sector gastronómico.</li>
            <li><b>Comparador de Salarios:</b> Obtén información sobre las condiciones salariales y
            contractuales en el sector gastronómico.</li>
            <li><b>Explorador de Empresas:</b> Conoce las empresas del sector, sus ofertas de empleo y
            otros servicios relacionados.</li>
            <li><b>Foro Interactivo:</b> Participa en un foro donde los usuarios pueden intercambiar
            experiencias, compartir conocimientos y comunicarse con otros profesionales y
            empresas del sector.</li>
          </ul>
          <p>
            GourmetJobs se reserva el derecho de modificar, suspender o eliminar cualquiera de estos
            servicios en cualquier momento, sin previo aviso.
          </p>

          <h3>II. Definiciones</h3>
          <ul>
            <li><b>Usuario:</b> Persona que accede y utiliza los servicios de GourmetJobs, ya sea como
            empleador (empresa) o profesional (trabajador).</li>
            <li><b>Empresa:</b> Institución del sector gastronómico que publica ofertas laborales y/o
            utiliza los servicios de GourmetJobs para contratar personal.</li>
            <li><b>Profesional:</b> Persona registrada en la plataforma que busca oportunidades laborales
            en el sector gastronómico.</li>
            <li><b>Perfil:</b> Información personal que cada Usuario debe ingresar al registrarse en la
            plataforma, que puede incluir datos como nombre, dirección de contacto, historial
            laboral, etc.</li>
            <li><b>Moderador:</b> Persona encargada de mantener el orden y el cumplimiento de las
            normas en el foro y otras secciones interactivas de la plataforma.</li>
          </ul>

          <h3>III. Perfil de Usuario</h3>
          <p>
            Los usuarios de GourmetJobs, ya sean profesionales o empresas, pueden crear un perfil
            gratuitamente en la plataforma. Un Usuario puede tener un perfil de profesional y un perfil
            de empresa, pero no más de un perfil por tipo.
          </p>
          <p>
            El Usuario es responsable de la veracidad, exactitud, vigencia y titularidad de los datos
            proporcionados en su perfil. En caso de que un tercero acceda al perfil del Usuario de
            forma no autorizada, GourmetJobs no se hace responsable de los perjuicios que puedan
            derivarse de dicho acceso.
          </p>
          <p>
            Los menores de 18 años deberán contar con la autorización de un padre, madre o tutor para
            su registro.
          </p>
          <p>
            El Usuario debe usar la plataforma correctamente, conforme a los presentes Términos y
            Condiciones, respetando la legislación aplicable y manteniendo un comportamiento
            adecuado en las interacciones con otros usuarios.
          </p>

          <h3>IV. Tratamiento de Datos y Política de Privacidad</h3>
          <p>
            Al aceptar estos Términos y Condiciones, el Usuario autoriza a GourmetJobs a utilizar
            comercialmente la información proporcionada con el fin de mejorar la empleabilidad y la
            capacitación en el sector gastronómico.
          </p>
          <p>
            Las empresas y reclutadores registrados podrán acceder a los datos proporcionados por los
            profesionales para fines de reclutamiento y contacto. GourmetJobs podrá utilizar la
            información personal para fines estadísticos, comerciales, publicitarios, o de seguridad,
            respetando la confidencialidad de los datos personales.
          </p>

          <h3>V. Prohibiciones al Usuario</h3>
          <ul>
            <li>Utilizar la plataforma para fines ilícitos o contrarios a los intereses de
            GourmetJobs o de terceros.</li>
            <li>Proveer información falsa, incompleta o adulterada en su perfil.</li>
            <li>Usar software o dispositivos que dañen o interfieran con el normal funcionamiento
            de la plataforma.</li>
            <li>Publicar material que sea ilegal, ofensivo, difamatorio, discriminatorio o que atente
            contra los derechos de otros usuarios.</li>
          </ul>
          <p>
            Cualquier infracción a estas prohibiciones podrá resultar en la suspensión o eliminación del
            perfil del Usuario.
          </p>

          <h3>VI. Derechos de Propiedad Intelectual</h3>
          <p>
            Todos los derechos de propiedad intelectual relacionados con el contenido, las marcas, los
            logotipos y cualquier otro material de GourmetJobs pertenecen a GourmetJobs SpA. El
            acceso y uso de la plataforma no concede al Usuario ningún derecho sobre estos derechos
            de propiedad intelectual.
          </p>

          <h3>VII. Normas para el Uso del Foro Interactivo</h3>
          <ul>
            <li>Participar de manera respetuosa y constructiva.</li>
            <li>No publicar contenido que sea ilegal, ofensivo o que infrinja derechos de propiedad.</li>
            <li>No divulgar información personal de terceros sin su consentimiento.</li>
          </ul>
          <p>
            GourmetJobs se reserva el derecho de moderar, eliminar o modificar cualquier contenido
            en el foro que infrinja estos Términos y Condiciones.
          </p>

          <h3>VIII. Modificaciones y Condiciones de Prestación del Servicio</h3>
          <p>
            GourmetJobs podrá modificar estos Términos y Condiciones en cualquier momento. Las
            modificaciones serán puestas en conocimiento del Usuario a través de la plataforma o por
            correo electrónico. El uso continuo de la plataforma después de las modificaciones
            implicará la aceptación de las nuevas condiciones.
          </p>

          <h3>IX. Terminación o Eliminación de un Perfil de Usuario</h3>
          <p>
            El Usuario podrá solicitar la eliminación de su perfil en cualquier momento enviando un
            correo a <a href="mailto:hola@gourmetjobs.cl">hola@gourmetjobs.cl</a>. La infracción a las condiciones de uso podrá resultar en la
            cancelación inmediata del perfil.
          </p>

          <h3>X. Solución de Controversias</h3>
          <p>
            Cualquier controversia relacionada con el uso de la plataforma será sometida a los
            tribunales de justicia de la comuna de Santiago, Chile. Estos Términos y Condiciones se
            rigen por las leyes de la República de Chile.
          </p>

          <h3>XI. Información de Contacto</h3>
          <ul>
            <li><b>Razón Social:</b> GourmetJobs SpA</li>
            <li><b>RUT:</b> 77.865.723-6</li>
            <li><b>Dirección:</b> Apoquindo 6410, Las Condes, Chile</li>
            <li><b>Correo electrónico:</b> <a href="mailto:hola@gourmetjobs.cl">hola@gourmetjobs.cl</a></li>
            <li><b>Representante Legal:</b> Hernán Eduardo Azócar Soto</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;